import { addDays, addMonths } from "date-fns";
import { toDate, isoOf, daysBetween } from "@/lib/brand";

export const todayIn = (tz) => {
  try { return new Intl.DateTimeFormat("en-CA", { timeZone: tz || "UTC" }).format(new Date()); } catch { return isoOf(new Date()); }
};

const yearly = (orig, year, policy) => {
  const leap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
  if (orig.getMonth() === 1 && orig.getDate() === 29 && !leap(year)) return policy === "feb28" ? new Date(year, 1, 28) : new Date(year, 2, 1);
  return new Date(year, orig.getMonth(), orig.getDate());
};

export function nextOccurrence(iso, rule, todayIso, policy = "feb28") {
  const orig = toDate(iso);
  const today = toDate(todayIso);
  if (!orig || !rule || rule === "one_time" || orig >= today) return iso;
  if (rule === "daily") return todayIso;
  if (rule === "weekly") return isoOf(addDays(orig, 7 * Math.ceil((today - orig) / (7 * 86400000))));
  if (rule === "monthly" || rule === "quarterly") {
    const step = rule === "monthly" ? 1 : 3;
    for (let k = 0; k < 2400; k += step) { const c = addMonths(orig, k); if (c >= today) return isoOf(c); }
  }
  if (rule === "yearly") {
    for (const y of [today.getFullYear(), today.getFullYear() + 1]) { const c = yearly(orig, y, policy); if (c >= today) return isoOf(c); }
  }
  return iso;
}

export const daysLeft = (iso, rule, todayIso, policy) => daysBetween(todayIso, nextOccurrence(iso, rule, todayIso, policy));
